import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useState } from "react";

import MergeTagChip from "components/Editor/MergeTagWarning/MergeTagChip";

import styles from "../styles";

export function OneTweak() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box component="button" type="button" sx={styles.oneTweakCard}>
      <Box
        component="i"
        className="fa-regular fa-lightbulb"
        sx={styles.oneTweakIcon}
      />
      <Box sx={styles.oneTweakContent}>
        <Typography>
          <strong>Personalize your first sentence to lift replies</strong>
        </Typography>

        <Typography gutterBottom>
          Start with a compelling sentence that makes you stand out.
          {expanded && (
            <>
              {" "}
              Explain why you're reaching out to them specifically, and
              highlight what makes you a strong fit—whether that's your unique
              audience, creative angle, or results you've delivered for similar
              brands. This immediately shows genuine interest and credibility.
            </>
          )}
        </Typography>

        {expanded && (
          <Box sx={{ mt: 4, borderLeft: `4px solid ${grey[300]}`, pl: 2 }}>
            Example: <br />
            <em>
              I had to reach out-
              <MergeTagChip mergeTag="{Brand Name}" />
              is super similar to a recent partnership I did with Kosas, where I
              created a tutorial (think: big sister vibes) that got 500K+ views
              (linked here)! I'd love to explore something similar together!
            </em>
          </Box>
        )}

        <Box
          component="span"
          role="button"
          tabIndex={0}
          onClick={(e) => {
            e.stopPropagation();
            setExpanded((prev) => !prev);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              e.stopPropagation();
              setExpanded((prev) => !prev);
            }
          }}
          sx={styles.oneTweakReadMore}
        >
          {expanded ? "Show less" : "Read more"}
        </Box>
      </Box>
    </Box>
  );
}

export default OneTweak;
